export const subscriptionLoading =  ({store})  => store.subscriptionReducer.loading;

export const subscriptionError =  ({store})  => store.subscriptionReducer.error;

export const subscriptionData =  ({store})  => store.subscriptionReducer.data;